export const formatINR = (value) =>
  new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 })
    .format(Number(value) || 0);

export const formatUnits = (value) =>
  new Intl.NumberFormat('en-IN', { maximumFractionDigits: 3 }).format(Number(value) || 0);

export const formatPct = (value) => `${(Number(value) || 0).toFixed(2)}%`;

// Backend timestamps are UTC without a zone suffix; read them as UTC, not local time.
const parseTimestamp = (value) => {
  const text = String(value);
  const naive = /^\d{4}-\d{2}-\d{2}T[\d:.]+$/.test(text);
  return new Date(naive ? `${text}Z` : text);
};

export const formatAsOf = (value) => {
  if (!value) return '';
  const date = parseTimestamp(value);
  return Number.isNaN(date.getTime())
    ? ''
    : date.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
};

// e.g. "15 Oct 2026, 7:30 pm"
export const formatFetchedAt = (value) => {
  if (!value) return '';
  const date = parseTimestamp(value);
  if (Number.isNaN(date.getTime())) return '';
  const time = date.toLocaleTimeString('en-IN', { hour: 'numeric', minute: '2-digit', hour12: true });
  return `${formatAsOf(value)}, ${time}`;
};

// Fund-house / bank acronyms that should stay upper-case after title-casing
const ACRONYMS = new Set([
  'UTI', 'HDFC', 'ICICI', 'SBI', 'DSP', 'HSBC', 'IDFC', 'LIC', 'PGIM', 'ITI', 'JM', 'BOI',
  'IIFL', 'NJ', 'WOC', 'AMC', 'ETF', 'FOF', 'IDBI', 'NPS', 'PPFAS', 'UBI',
]);

export const titleCase = (text) =>
  String(text || '')
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/\b\w+/g, (word) => (ACRONYMS.has(word.toUpperCase())
      ? word.toUpperCase()
      : word.charAt(0).toUpperCase() + word.slice(1)));

// Compact Indian amounts for summary cards: ₹1.12 Cr, ₹20.12 L, below a lakh in full (₹45,000).
export const formatLakhCr = (value) => {
  const amount = Number(value) || 0;
  const abs = Math.abs(amount);
  const sign = amount < 0 ? '-' : '';
  const fixed = (n) => n.toFixed(2).replace(/\.?0+$/, '');
  if (abs >= 1e7) return `${sign}₹${fixed(abs / 1e7)} Cr`;
  if (abs >= 1e5) return `${sign}₹${fixed(abs / 1e5)} L`;
  return formatINR(amount);
};
